/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-30 18:57:40
 */

import Api from "src/util/api";
import {PageDo, Result, ResultPageDo, Integer, IViewDate} from "src/types/base";
import { defaultNullValue } from 'src/config';
export declare namespace SystemSetDOI {

	export interface RowDataI {
        id: number
        district_name : string
        province_name : string
        city_name     : string
        type          : number
        agreement_name: string
        basin         : string
        status        : number
	}

	export interface QueryRowDataParamsI extends PageDo {
		province_id : Integer,
		city_id     : Integer,
		district_id : Integer,
		agreement_id: Integer,
		basin_id    : Integer,
		type        : Integer,
		name_mn     : string
	}

	export interface QueryDetailResultI {
        name             : string
        type             : Integer
        mn               : string
        section          : string
        location_point   : string
        district_id      : number
        province_id      : number
        city_id          : number
        address          : string
        agreement_id     : Integer
        meter_time       : Integer
        product_id       : Integer
        water_level      : Integer
        power_type       : Integer
        basin            : string
        msisdn           : string
        fakedata_status  : Integer
        devops_personnel : string
        devops_mobile    : string
        remark           : string
        control_hierarchy: Integer
        factorset        : Integer
        is_sort          : Integer
        component_id: Integer;
        decimal_place:Integer;
        alarm_value      : Integer;
        alarm_mn : string;
        built_time:IViewDate;
        reception_time:IViewDate;
	}

	export interface OperateParamsI {
        id?: Integer
        mn: string
        device_name: string
        ip: string
        port: string
	}

}
export default class SystemSetApi {
	/**
	 * 查询列表
	 * @param {SystemSetDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: SystemSetDOI.QueryRowDataParamsI):Promise<ResultPageDo<SystemSetDOI.RowDataI[]>> {
		return Api.post('/monitor/point/device/data/other/real', {
            province_id: defaultNullValue,
            city_id: defaultNullValue,
            district_id: defaultNullValue,
            agreement_id: defaultNullValue,
            basin_id: defaultNullValue,
            type: defaultNullValue,
            name_mn: '',
            ...params
        })
	}
	/**
	 * 查询列表
	 * @param {{id: number}} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchDetail (device_id: number): Promise<Result<SystemSetDOI.QueryDetailResultI[]>> {
		return Api.post('/monitor/id/by/device/query', {device_id})
	}
	/**
	 * 新增
	 * @param {SystemSetDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async add(data:SystemSetDOI.OperateParamsI):Promise<Result<any>> {
		return Api.post('/monitor/point/device/add', data)
	}

	/**
	 * 修改
	 * @param {SystemSetDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async update(data:SystemSetDOI.OperateParamsI):Promise<Result<any>> {
		return Api.post('/monitor/point/device/edit', data)
	}

	/**
	 * 删除
	 * @param {Array<number>} data
	 * @returns {Promise<Result<any>>}
	 */
	static async delete(data:{device_ids: Array<number>}):Promise<Result<any>> {
		return Api.post('/monitor/point/devices/delete', data)
    }

    /**
	 * 删除
	 * @param {Array<number>} data
	 * @returns {Promise<Result<any>>}
	 */
	static async queryBasin(data:{name: string, page_index: number, page_size: number}):Promise<ResultPageDo<{id: number, name: string}>> {
		return Api.post('/monitor/point/basin/data', {
            page_index: 1,
            page_size: 10000000,
            name: '',
            ...data
        })
    }

    static async queryAgreement(data:{page_index: number, page_size: number}):Promise<ResultPageDo<{id: number, name: string}>> {
		return Api.post('/monitor/point/agreement/data', data)
    }

    static async queryMeasuring(data:{page_index: number, page_size: number}):Promise<ResultPageDo<{id: number, name: string}>> {
		return Api.post('/monitor/measuring/type/query', data)
    }
    static async queryComponentProduct(data:{page_index: number, page_size: number}):Promise<ResultPageDo<{id: number, name: string}>> {
		return Api.post('/monitor/component_product/query', data)
    }

    /**
     * 根据因子组id查询因子组信息
     * @param params
     */
    static async queryComponentProductDetails(params: any):Promise<ResultPageDo<{id: number, name: string}>>{
      return Api.post('/monitor/component_product_id/by_component/get', params)
    }

    /**
     * 根据因子id查询保留小数位数
     * @param params
     */
    static async queryComponentDecimalPlace(params: any):Promise<ResultPageDo<{decimal_place_value: number}>>{
      return Api.post('/monitor/component/by_decimal_place/get', params)
    }

    /**
     * 湖南添加设备
     * @param params
     */
    static async addDevice(params: any) {
        return Api.post('/monitor/hunan/point/device/add', params)
    }

    /**
     * 湖南编辑设备
     * @param params
     */
    static async editDevice(params: any) {
        return Api.post('/monitor/hunan/point/device/edit', params)
    }

    /**
     * 湖南删除设备
     * @param params
     */
    static async deleteDevice(params: any) {
        return Api.post('/monitor/hunan/point/device/delete', params)
    }

    /**
     * 根据id查询湖南设备详情
     * @param params
     */
    static async queryDevice(params: any) {
        return Api.post('/monitor/hunan/id/by/device/query', params)
    }

    /**
     * 查询湖南设备列表
     * @param params
     */
    static async listDevicePage(params: any) {
        return Api.post('/monitor/hunan/point/device/data/other/real', params)
    }
}
